import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classes from './ResetPassword.module.css';
import Logo from 'assets/images/logos/logo-dark-backgrounds.svg';
import PasswordCriteriaHelper from 'components/Auth/PasswordCriteriaHelper/PasswordCriteriaHelper';
import Button from 'components/UI/Button/Button';
import Input from 'components/UI/Input/Input';
import { checkValidity, updateObject } from 'shared/utility';
import * as actions from 'store/actions';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controls: {
        password: {
          elementType: 'input',
          elementConfig: {
            type: 'password',
            placeholder: 'Password',
            autocomplete: 'new-password',
          },
          value: '',
          validation: {
            required: true,
            minLength: 7,
            validationError: '',
          },
          valid: false,
          touched: false,
        },
        passwordConfirmation: {
          elementType: 'input',
          elementConfig: {
            type: 'password',
            placeholder: 'Password Confirmation',
          },
          value: '',
          validation: {
            required: true,
            matchesPassword: true,
            validationError: '',
          },
          valid: false,
          touched: false,
        },
      },
      passwordRevealed: false,
      formIsValid: false,
      // passwordUpdated: false,
      // error: this.props.error,
    };
  }

  componentDidMount() {
    if (this.props.match.params.tempPass && this.props.match.params.tempPass.includes('&Temp=')) {
      const tempPass = this.props.match.params.tempPass.replace('&Temp=', '');
      this.props.onSignIn(null, null, tempPass);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.passwordUpdated === true && prevProps.passwordUpdated === false) {
      this.props.history.push({ pathname: '/' });
    }
  }

  inputChangedHandler = (event, controlName) => {
    const isValid = checkValidity(event.target.value, this.state.controls[controlName].validation, this.state.controls.password.value);
    const updatedControls = updateObject(this.state.controls, {
      [controlName]: updateObject(this.state.controls[controlName], {
        value: event.target.value,
        valid: isValid,
        touched: isValid === true,
      }),
    });
    let formIsValid = true;
    for (const inputIdentifier in updatedControls) {
      formIsValid =
        updatedControls[inputIdentifier].validation.required ||
        (updatedControls[inputIdentifier].value && updatedControls[inputIdentifier].value.length > 1)
          ? updatedControls[inputIdentifier].valid && formIsValid
          : formIsValid;
    }
    this.setState({ controls: updatedControls, formIsValid });
  };

  submitNewPassword = () => {
    this.props.onPasswordUpdate(this.state.controls.password.value);
  };

  handleNewResetRedirect = () => {
    this.props.onClearAppError();
    this.props.onLogout();
    this.props.history.push('/request-password-reset');
  };

  render = () => {
    let errorMessage = null;
    if (this.props.error) {
      errorMessage = <p className={classes.ErrorMessage}>{this.props.error.replace(/_/g, ' ')}</p>;
    }

    return (
      <div className={classes.ResetPasswordContainer}>
        <div className={classes.AuthLogo}>
          <img src={Logo} alt="riza" />
        </div>
        <h2 className={classes.Intro}>Reset Password</h2>
        <div className={classes.ResetPasswordForm}>
          {errorMessage}
          <div>
            <Input
              value={this.state.controls.password.value}
              fontIcon={this.state.controls.password.value.length === 0 ? null : this.state.passwordRevealed ? 'eye-slash' : 'eye'}
              iconClicked={() => this.setState({ passwordRevealed: !this.state.passwordRevealed })}
              revealPassword={!!(this.state.controls.password.value.length > 0 && this.state.passwordRevealed === true)}
              inputClassName="AuthInput"
              elementType={this.state.controls.password.elementType}
              elementConfig={this.state.controls.password.elementConfig}
              invalid={!this.state.controls.password.valid}
              touched={this.state.controls.password.touched}
              shouldValidate={this.state.controls.password.validation !== null}
              validationError={this.state.controls.password.validation ? this.state.controls.password.validation.validationError : null}
              placeholder={this.state.controls.password.elementConfig.placeholder}
              changed={(event) => this.inputChangedHandler(event, 'password')}
            />
            <Input
              value={this.state.controls.passwordConfirmation.value}
              inputClassName="AuthInput"
              revealPassword={!!(this.state.controls.password.value.length > 0 && this.state.passwordRevealed === true)}
              elementType={this.state.controls.passwordConfirmation.elementType}
              elementConfig={this.state.controls.passwordConfirmation.elementConfig}
              invalid={!this.state.controls.passwordConfirmation.valid}
              touched={this.state.controls.passwordConfirmation.touched}
              shouldValidate={this.state.controls.passwordConfirmation.validation !== null}
              validationError={
                this.state.controls.passwordConfirmation.validation ? this.state.controls.passwordConfirmation.validation.validationError : null
              }
              placeholder={this.state.controls.passwordConfirmation.elementConfig.placeholder}
              changed={(event) => this.inputChangedHandler(event, 'passwordConfirmation')}
            />
          </div>
          <PasswordCriteriaHelper
            disabled={!this.state.controls.password.touched && !this.state.controls.passwordConfirmation.value}
            password={this.state.controls.password.value}
            passwordConfirmation={this.state.controls.passwordConfirmation.value}
            passwordConfirmationTouched={this.state.controls.passwordConfirmation.touched}
          />
          <div className={classes.ButtonContainer}>
            <Button btnType="Success" disabled={this.state.formIsValid === false} clicked={this.submitNewPassword}>
              Reset and Sign In
            </Button>
          </div>
          <p className={classes.RequestNewReset} onClick={this.handleNewResetRedirect}>
            Request New Password Reset
          </p>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    sessionToken: state.auth.sessionToken,
    passwordUpdated: state.user.passwordUpdated,
    error: state.auth.signInError !== null ? state.auth.signInError : state.user.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSignIn: (email, password, tempPass) => dispatch(actions.signIn(email, password, tempPass)),
    onLogout: () => dispatch(actions.logout()),
    onPasswordUpdate: (password) => dispatch(actions.updatePassword(password)),
    onClearAppError: () => dispatch(actions.clearAppError()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResetPassword));
